import axios from "axios";
import { t } from "../texts.js";
const url = window.location.origin;
// French, German and Italian pages live under /fr, /de and /it; the layout puts the visitor's
// prefix on <html>. Links to the site's pages keep it, so a search doesn't drop the language.
const sitePrefix = document.documentElement.dataset.sitePrefix || "";
const pageUrl = (address) => {
  const link = new URL(address, url);
  if (link.origin !== url && !/^(www\.)?orgreenoptics\.com$/i.test(link.hostname)) {
    return address;
  }
  return `${url}${sitePrefix}${link.pathname}${link.search}${link.hash}`;
};
const filterUrlAlternative = document.querySelector("[data-filter-url]");
let filterUrl = "/product/filter/products";

if(filterUrlAlternative) {
  filterUrl = "/product/filter/archive/products"
} 

// Search
///////////////////

// Functions
let renderAutocompleteList = (wrapper, results) => {
  results.forEach((itemResult) => {
    console.log(itemResult.product_url);
    wrapper.querySelector("ul").insertAdjacentHTML(
      "beforeend",
      `
            <li>
                <a class="notranslate" translate="no" href="${pageUrl(itemResult.product_url ? itemResult.product_url : "/404")}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 8.43961C13 11.4598 10.5376 13.9082 7.5 13.9082C4.46243 13.9082 2 11.4598 2 8.43961C2 5.41939 4.46243 2.97101 7.5 2.97101C10.5376 2.97101 13 5.41939 13 8.43961ZM15 8.43961C15 12.5581 11.6421 15.8968 7.5 15.8968C3.35786 15.8968 0 12.5581 0 8.43961C0 4.32112 3.35786 0.982422 7.5 0.982422C11.6421 0.982422 15 4.32112 15 8.43961ZM12.1082 14.3237C12.5966 13.9449 13.0367 13.5074 13.4177 13.0217L18.0524 17.63C18.414 17.9896 18.414 18.5725 18.0524 18.932C17.6908 19.2916 17.1046 19.2916 16.743 18.932L12.1082 14.3237Z" fill="#3F4753"/>
                    </svg>
                    ${itemResult.parent}
                </a>
            </li>
        `,
    );
  });
  let linkLocationArray = [];
  linkLocationArray = results.map((e) => {
    return e.parent;
  });

  // // Search button location
  let buttonSearchLocation = document.querySelectorAll(".js-search-location");

  Array.from(buttonSearchLocation).forEach((item) => {
    if (linkLocationArray.length !== 0) {
      item.href = pageUrl(`/eyeglasses?name=${linkLocationArray.join()}`);
    } else {
      item.href = pageUrl("/eyeglasses");
    }
  });
};

// Search autocomplete
let inputAutoComplete = document.querySelectorAll(".input--search input");
Array.from(inputAutoComplete).forEach((e) => {
  const inputSearchButton = e.parentNode
    .closest(".input")
    .querySelector(".input-search__reset");
  let searchProductResult = [];

  // Reset input button
  inputSearchButton.addEventListener("click", (e) => {
    let inputContainer = e.currentTarget.parentNode.closest(".input");
    let inputSearchElement = e.currentTarget.parentNode
      .closest(".input")
      .querySelector("input");
    let inputAutoComplete = inputContainer.querySelector(
      ".input-search__autocomplete",
    );

    inputContainer.classList.remove("input--show-results");
    inputContainer.classList.remove("input--no-empty");
    inputAutoComplete.removeAttribute("style");
    inputAutoComplete.querySelector("ul").innerHTML = "";
    inputSearchElement.value = "";
    searchProductResult = [];
  });

  // Input state
  e.addEventListener("input", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");

    let inputAutoComplete = inputContainer.querySelector(
      ".input-search__autocomplete",
    );
    inputAutoComplete.querySelector("ul").innerHTML = `
            <li class="loading">
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="12" viewBox="0 0 44 12" fill="#CFD1D4">
            	<defs>
            		<style>
                    .dot { transform-origin: 50% 50%; -webkit-transform-origin: 50% 50%;
                    	-webkit-animation: bouncedelay 1s infinite ease-in-out both; 
                    	animation: bouncedelay 1s infinite ease-in-out both; }
                    .dot-1 { -webkit-animation-delay: -.54s; animation-delay: -.54s}
                    .dot-2 { -webkit-animation-delay: -.48s; animation-delay: -.48s}
                    .dot-3 { -webkit-animation-delay: -.32s; animation-delay: -.32s}
                    @-webkit-keyframes bouncedelay {
                    	0%,80%,100%{ -webkit-transform: scale(0.8); }	40%{ -webkit-transform: scale(1); } }
                    @keyframes bouncedelay {
                    	0%,80%,100%{ transform: scale(0.8); }	40%{ transform: scale(1); } }
            		</style>
            	</defs>
            	<circle class="dot dot-1" cx="6"  cy="6" r="6"/>
            	<circle class="dot dot-2" cx="22" cy="6" r="6"/>
            	<circle class="dot dot-3" cx="38" cy="6" r="6"/>
            </svg>
         </li>`;

    if (input.currentTarget.value.length > 1) {
      inputContainer.classList.add("input--show-results");
      console.log(`${url}${filterUrl}`)
      axios({
        method: "get",
        url: `${url}${filterUrl}?name=${input.currentTarget.value}`,
      })
        .then((response) => {
          if (response.data.length !== 0) {
            inputAutoComplete.querySelector("ul").innerHTML = "";
            renderAutocompleteList(inputAutoComplete, response.data);
          } else {
            inputAutoComplete.querySelector("ul").innerHTML = "";
            inputAutoComplete
              .querySelector("ul")
              .insertAdjacentHTML(
                "beforeend",
                `<li class="not-found">${t("No products found")}</li>`,
              );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      inputContainer.classList.remove("input--show-results");
      inputContainer.querySelector(".js-search-location").href =
        pageUrl("/eyeglasses");
    }
  });

  // Focus state
  e.addEventListener("focus", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");

    if (
      searchProductResult.length !== 0 &&
      input.currentTarget.value.length > 1
    ) {
      inputContainer.classList.add("input--show-results");
    }
  });

  // UnFocus state
  e.addEventListener("focusout", (input) => {
    let inputContainer = input.currentTarget.parentNode.closest(".input");
    let inputAutoComplete = inputContainer.querySelector(
      ".input-search__autocomplete",
    );

    document.addEventListener("click", (e) => {
      if (e.target.closest(".input") === null) {
        inputAutoComplete.removeAttribute("style");
        inputContainer.classList.remove("input--show-results");

        if (searchProductResult.length === 0) {
          inputAutoComplete.querySelector("ul").innerHTML = "";
        }
      }
    });
  });
});
